import { useMemo } from 'react';

export const useEnvironment = () => {
  return useMemo(() => {
    const environment = process.env.REACT_APP_ENVIRONMENT || 'unknown';

    const isProd = environment === 'production';
    const isStaging = environment === 'staging';

    return {
      isProd,
      isStaging,
    };
  }, []);
};
